import { View, Text, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const MaterialDistributionBlock = ({
  numberOfObjects,
  materialChartImgData,
}) => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        paddingHorizontal: 20,
        justifyContent: "space-between",
      }}
    >
      <View style={{ width: "30%" }}>
        <View>
          <Text
            style={{
              fontSize: 18,
              color: "#00A7A6",
              fontFamily: "Mulish",
              fontWeight: 1000,
              letterSpacing: "1px",
            }}
          >
            {t("Material distribution")}
          </Text>
        </View>
        <View style={{ marginTop: 35 }}>
          <Text
            style={{
              fontSize: 18,
              fontFamily: "Mulish",
              color: "#e81d7a",
              fontWeight: 1000,
            }}
          >
            {numberOfObjects}
          </Text>
          <Text
            style={{
              fontSize: 12,
              fontFamily: "Mulish",
            }}
          >
            {numberOfObjects > 1
              ? t("Detected materials")
              : t("Detected material")}
          </Text>
        </View>
      </View>
      <View
        style={{
          width: "70%",
          justifyContent: "flex-start",
        }}
      >
        {materialChartImgData && (
          <Image
            style={{ width: "370px", height: "auto" }}
            src={materialChartImgData}
          />
        )}
      </View>
    </View>
  );
};

export default MaterialDistributionBlock;
